"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function QuaratinesnapshotsMulticolorOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__quaratinesnapshots-multicolor-outline__clip0_16228_3932)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCE5FF",
    d: "M8.392 12.456a3.704 3.704 0 100-7.408 3.704 3.704 0 000 7.408z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M6.968 2.2l.128.08a4.98 4.98 0 00-.36 1.484l-4.5 2.824 1.084.704c.087.05.162.12.216.204.03.048.054.1.068.156v.056a.987.987 0 010 .112.545.545 0 010 .08v.06a.256.256 0 01-.024.072.521.521 0 01-.032.068.188.188 0 01-.02.04l-.02.024a.632.632 0 01-.048.06.724.724 0 01-.12.1l-.036.02a.572.572 0 01-.28.072.616.616 0 01-.308-.084l-.8-.512L.004 6.58 6.968 2.2zM11.268 8.276a.604.604 0 00-.048-.964l.768.484-.72.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.268 8.276a.604.604 0 00-.048-.964l.768.484-.72.48zM13.9 9.012l-1.908 1.232-.8.508a.608.608 0 01-.648.004.588.588 0 01-.272-.452.588.588 0 01.092-.376l.036-.048.036-.044a.712.712 0 01.084-.076h.024l.048-.028h.028l.676-.44c.155.016.312.024.468.024a4.968 4.968 0 001.94-.4l.196.096zM3.036 10.848a.6.6 0 01-.324-.096L0 9.008l2.716-1.7a.6.6 0 01.64 1.016l-1.116.7 1.12.72a.596.596 0 01-.037 1.03.6.6 0 01-.287.074z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.912 8.388c.382.267.801.477 1.244.624l-3.168 2.056-3.94-2.54-.304-.192a.608.608 0 01-.18-.832.624.624 0 01.16-.164.331.331 0 01.064-.036l.064-.032a.332.332 0 01.06-.048.543.543 0 01.116 0H3.256l.06.028h.032l3.6 2.324 1.964-1.188z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M6.972 15.932L.004 11.448 2.716 9.74a.6.6 0 11.64 1.016l-1.12.704 4.732 3.044 4.704-3.044-1.116-.708a.596.596 0 01-.184-.828.6.6 0 01.828-.184l2.7 1.708-6.928 4.484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M6.972 13.496l-4.26-2.744a.597.597 0 01-.018-.997.596.596 0 01.666-.01l3.6 2.32 3.6-2.32a.6.6 0 01.652 1.007l-4.24 2.744z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.268 8.276a.604.604 0 00-.048-.964l.768.484-.72.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.776 8.448a4.228 4.228 0 01-4.224-4.224A4.228 4.228 0 0111.776 0 4.232 4.232 0 0116 4.224a4.232 4.232 0 01-4.224 4.224zm0-7.248a3.028 3.028 0 00-3.024 3.024 3.028 3.028 0 003.024 3.024A3.028 3.028 0 0014.8 4.224 3.028 3.028 0 0011.776 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M11.772.6v3.62H8.148A3.624 3.624 0 0111.772.6zM15.4 4.22a3.628 3.628 0 01-3.628 3.628V4.22H15.4z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__quaratinesnapshots-multicolor-outline__clip0_16228_3932"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V15.932H0z"
  }))));
}

QuaratinesnapshotsMulticolorOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
QuaratinesnapshotsMulticolorOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = QuaratinesnapshotsMulticolorOutline;
exports["default"] = _default;